// @flow
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import Layout from '../components/layout';
import PageMeta from '../components/PageMeta';

import awsLogo from '../assets/images/aws-logo.svg';
import azureLogo from '../assets/images/azure-logo.svg';
import googleCloudLogo from '../assets/images/google-cloud-logo.svg';

export default () => (
  <Layout>
    <PageMeta title="Cloud Development | CS Frequency" />
    <section className="module-page-title">
      <div className="container">
        <div className="row-page-title">
          <div className="page-title-captions">
            <h1 className="h3">Cloud Development</h1>
          </div>
          <div className="page-title-secondary">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <GatsbyLink to="/">Home</GatsbyLink>
              </li>
              <li className="breadcrumb-item active">Cloud</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section className="module module-divider-bottom">
      <div className="container">
        <div className="row m-b-100">
          <div className="col-md-12">
            <div className="special-heading">
              <h3>What we do</h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="icon-box">
              <div className="icon-box-title">
                <h6>Cloud Architecture and Migration</h6>
              </div>
              <div className="icon-box-content">
                <p>
                  We have extensive experience migrating large in-house
                  applications and workloads into the cloud. From web and
                  e-commerce applications to desktop applications and even large
                  processing pipelines, we can help you design, architect and
                  migrate to the cloud technology and platform that meets your
                  requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-b-100">
          <div className="col-md-12">
            <div className="special-heading">
              <h3>Technologies</h3>
            </div>
          </div>
          <div className="col-md-2 text-center">
            <a href="https://cloud.google.com/">
              <img className="product-logo" src={googleCloudLogo} />
            </a>
          </div>
          <div className="col-md-10">
            <div className="icon-box">
              <div className="icon-box-title">
                <h6>Google Cloud Platform (GCP)</h6>
              </div>
              <div className="icon-box-content">
                <p>
                  As leaders in Platform as a Service (PaaS) offerings, Google's
                  Cloud Platform focuses on reducing management and
                  infrastructure overhead to allow your developers to
                  concentrate on what they do best, building software. Safe in
                  the knowledge that Google use their cloud platform at the
                  heart of all their own services, you can be sure that their
                  technology will scale to any level you might need.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-2 text-center">
            <a href="https://aws.amazon.com/">
              <img className="product-logo" src={awsLogo} />
            </a>
          </div>
          <div className="col-md-10">
            <div className="icon-box">
              <div className="icon-box-title">
                <h6>Amazon Web Services (AWS)</h6>
              </div>
              <div className="icon-box-content">
                <p>
                  As the original cloud provider, it's hard to compete with the
                  sheer breadth of services that Amazon Web Services offer in
                  the cloud. Whilst their Platform as a Service (PaaS) offerings
                  might not match Google's simplicity or developer focus, if
                  you're looking for greater control over your cloud
                  infrastructure and environment then AWS may be the way to go.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-2 text-center">
            <a href="https://azure.microsoft.com/">
              <img className="product-logo" src={azureLogo} />
            </a>
          </div>
          <div className="col-md-10">
            <div className="icon-box">
              <div className="icon-box-title">
                <h6>Microsoft Azure</h6>
              </div>
              <div className="icon-box-content">
                <p>
                  As you'd expect from Microsoft, their cloud services offer
                  close integration with the rest of their web and desktop
                  offerings, from Office 365 and Dynamics to Active Directory.
                  If you're heavily invested in Microsoft back office systems,
                  Azure is a good choice.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="col-md-12">
            <div className="text-center">
              <GatsbyLink
                className="btn btn-lg btn-circle btn-brand"
                to="/hire-us/"
              >
                Hire Us
              </GatsbyLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);
